import { AuthenticationField } from "./AuthenticationField"
import { SolutionForSetup } from "~/src/types/solution"

type AuthValues = Record<string, string>

export type AuthenticationFieldsProps = {
  authentications: SolutionForSetup["authentications"]
  authValues: AuthValues
  solutionInstanceId: number
  onChange: (externalId: string, newValue: string) => void
}

export function AuthenticationFields({
  authentications,
  authValues,
  solutionInstanceId,
  onChange,
}: AuthenticationFieldsProps) {
  if (authentications.length === 0) {
    return null
  }

  return (
    <div className="pt-2 pb-8">
      <h2 className="pt-2 pb-4 text-xl font-medium">Connect to Services</h2>
      <div className="flex flex-col gap-4">
        {authentications.map((auth) => {
          const value = authValues[auth.externalId] ?? { externalId: auth.externalId, value: "" }

          return (
            <div key={auth.externalId} className="block w-auto">
              <AuthenticationField
                externalId={auth.externalId}
                solutionInstanceId={solutionInstanceId}
                title={auth.title}
                value={value}
                onChange={(newAuthId) => {
                  onChange(auth.externalId, newAuthId)
                }}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
